export const dir = () => {
    //location project directory
    const project_location = ''
    return project_location
}